import { Link } from "react-router-dom";

export default function Logo({ light = false }) {
  return (
    <Link to="/" data-testid="logo" className="select-none">
      <img
        src={light ? "/logo-mkn-white.png" : "/logo-mkn.webp"}
        alt="MKN Projects"
        width="121"
        height="44"
        loading={light ? "lazy" : "eager"}
        decoding="async"
        className="h-11 w-auto"
      />
    </Link>
  );
}
